document.addEventListener('DOMContentLoaded', function(){
	//Consts
	const b = $('body'),
			s = $('.slider'),
			minicart = $('#minicart-wrapper');
			isTouchDevice = () => {
				return (('ontouchstart' in window) ||
						 (navigator.maxTouchPoints > 0) ||
						 (navigator.msMaxTouchPoints > 0));
			};

	//Easing
	const speed   = 200,
			speedx2 = 400,
			ease    = 'easeInOutQuint';

	//Functions
	function height(){
		document.documentElement.style.cssText = `
			--h:  ${window.innerHeight}px;
			--hs: ${window.innerHeight - $('#header-wrapper').outerHeight(true)}px;
		`;
	}
	function marquee(M){
		M = $('.module-marquee');
		if(M.length){
			M.each(function(){
				var t = $(this),
					 w = t.width() - 30,
					 m = t.find('wrap').width();

				if(window.innerWidth > 600){
					var p = m / 25;
				}else{
					var p = m / 50;
				}
				t.css('animation-duration', p + 's')
			});
		}
	}
	function nextSlide(){
		if(!s.hasClass('transition')){
			s.addClass('transition').find('.slider-tracker').animate({
				'left': '-100%'
			}, speedx2, ease, function(){
				s.find('.slide:first-child').parent().append(s.find('.slide:first-child'));
				s.find('.slider-tracker').css('left', '0');
				s.removeClass('transition');
			});
			$('.video-player').removeClass('playing').find('video').trigger('pause');
			$('.dot').removeClass('active');
			$('.dot:nth-child('+$('.slide:first-child').next().data('slide')+')').addClass('active');
		}
	}
	function prevSlide(){
		if(!s.hasClass('transition')){
			s.find('.slide:last-child').parent().prepend(s.find('.slide:last-child'));
			s.addClass('transition').find('.slider-tracker').css('left', '-100%').animate({
				'left': '0'
			}, speedx2, 'easeInOutQuint', function(){
				s.removeClass('transition');
			});
			$('.video-player').removeClass('playing').find('video').trigger('pause');
			$('.dot').removeClass('active');
			$('.dot:nth-child('+s.find('.slide:first-child').data('slide')+')').addClass('active');
		}
	}
	function checkKey(e){
		e = e || window.event;
		if(e.keyCode == '37' && s.length){
			prevSlide()
		}else if(e.keyCode == '39' && s.length){
			nextSlide()
		}
	}
	function hideSearch(){
		if($('#pop-up_search').is(':visible')){
			$('#pop-up_search').fadeOut()
		}
	}
	function toggleCart(){
		minicart.toggle('slide', {
			direction: 'right',
			speed: speed,
			easing: ease,
			complete: function(){
				if($('menu').is(':visible') && window.innerWidth < 1025){
					$('#menu-trigger').toggleClass('active');
					$('menu').hide();
				}
				hideSearch()
			}
		});
	}
	function onLoadandResize(){
		height()
		marquee()
	}
	onLoadandResize()

	//Scroll Top on document ready
	if('scrollRestoration' in history){
		history.scrollRestoration = 'manual';
	}
	window.scrollTo(0,0);

	//Device detection
	if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) || isTouchDevice() == true){

		//If device
		b.addClass('mobile');
		//Pseudoclass :active on devices
		document.addEventListener('touchstart', function(){}, {passive: true});
		//Resize Functions
		window.addEventListener('orientationchange', function(){
			setTimeout(function(){
				onLoadandResize()
			}, 50);
		});
		//Slider
		if(s.length){
			let tsX = 0,
				 teX = 0;
			const s = document.getElementsByClassName('slider')[0];
			s.addEventListener('touchstart', function(event){
				tsX = event.changedTouches[0].screenX;
			}, false);
			s.addEventListener('touchend', function(event){
				teX = event.changedTouches[0].screenX;
				if(teX <= tsX && (tsX - teX > 50)){
					nextSlide()
				}
				if(teX >= tsX && (teX - tsX > 50)){
					prevSlide()
				}
			}, false);
		}

		//Featured Product
		$('.featured-product_dot').click(function(){
			$('.featured-product_dot').next().removeClass()
		});

	}else{

		//if Desktop
		b.addClass('desktop');
		//Resize Functions
		window.onresize = function(){
			onLoadandResize()
		}
		//Slider
		document.onkeydown = checkKey;

		//Featured Product
		$('.featured-product_dot').hover(function(){
			$('.featured-product_dot').next().removeClass()
		});

		//Stupid game
		$('.module-game_block').each(function(){
			var t = $(this),
				 o = t.offset(),
				 v = t.data('target');
			t.draggable({
				stop: function(e, ui){
					var x = o.left,
						 y = o.top,
						 left = ui.position.left,
						 top = ui.position.top - $(window).scrollTop(),
						 header = $('#header-wrapper').outerHeight(true),
						 halfW = (window.innerHeight - header) / 2;
					if(v == 'game-left'){
						if(left < 200
							&& top > halfW + header - 68
							&& top < halfW + header + 68){
							t.addClass('here')
						}
						if(left > window.innerWidth - 200
							&& top > halfW + header - 68
							&& top < halfW + header + 68){
							t.addClass('not-here')
						}
					}else{
						if(left < 200
							&& top > halfW + header - 68
							&& top < halfW + header + 68){
							t.addClass('not-here')
						}
						if(left > window.innerWidth - 200
							&& top > halfW + header - 68
							&& top < halfW + header + 68){
							t.addClass('here')
						}
					}
				},
				start: function(){
					t.removeClass('not-here')
				},
				scroll: false
			});
		});

		//Cursors
		var x, y;
		if($('.product-ingredient_img').length){
			$('.product-ingredient_title').each(function(){
				var t = $(this),
					 c = t.siblings('.product-ingredient_img');
				t.on('mousemove', function(e){
					c.show().css({
						left: e.pageX,
						top: e.pageY + 5
					});
				}).on('mouseleave', function(){
					c.hide()
				});
			});
		}

		//Module reviews
		$('.module-reviews_block .thumbnail').hover(function(){
			if(window.innerWidth > 834 && !$('.module-reviews_block .playing').length){
				$('.module-reviews_block').removeClass('active');
				$(this).parent().addClass('active')
			}
		});

	}

	//Draggable
	const drag = $('.autoscroll');
	if(drag.length){
		var p,
			 scroller,
			 timer = function(){
				scroller = setInterval(function(){
					var psw = drag.get(0).scrollWidth,
						 pos = drag.scrollLeft();
					if(psw - pos != $(document).width()){
						drag.scrollLeft(++pos);
					}else{
						clearInterval(scroller);
					}
				}, 40);
			 },
			 observer = new IntersectionObserver(function(E){
				E.forEach(function(entry){
					if(window.innerWidth > 600){
						if(entry.isIntersecting){
							clearInterval(scroller);
							timer();
						}else{
							clearInterval(scroller);
						}
					}
				});
			});
		if(b.hasClass('desktop')){
			drag.draggable({
				start: function(e, ui){
					if(window.innerWidth > 600){
						p = drag.scrollLeft();
					}
				},
				drag: function(e, ui){
					if(window.innerWidth > 600){
						drag.scrollLeft(p + ui.position.left * -1);
						clearInterval(scroller);
						observer.unobserve(drag[0]);
					}
				}
			});
		}
		setTimeout(function(){
			observer.observe(drag[0]);
		}, speed);
	}

	//Module reviews
	$('.module-reviews_block .thumbnail').click(function(){
		if(window.innerWidth > 834){
			$('.module-reviews_block').removeClass('active');
			$(this).parent().addClass('active')
		}
	})

	//Video Player
	$('.video-player').each(function(){
		var t = $(this),
			 v = t.find('video'),
			 play = t.find('.video-player_play');

		t.find('.video-player_play').click(function(){
			if(v[0].paused){
				$('.video-player').removeClass('playing')
										.find('video').trigger('pause');
				v[0].play();
				t.addClass('playing')
			}else{
				v[0].pause();
				t.removeClass('playing')
			}
		});

	});

	//Replace &nbsp;
	if($('.clear').length){
		$('.clear').html(function(i, html){
			return html.replace(/&nbsp;/g, ' ');
		});
		$('.clear div:not(.exclude):not(br)').each(function(){
			$(this).filter(function(){
				return $(this).text().trim().length == 0;
			}).remove();
		});
	}
	if($('input.caption').length){
		$('input.caption').each(function(){
			if($(this).val().length === 0){
				$(this).parent('.exclude').remove()
			}
		});
	}

	//Loader
	setTimeout(function(){
		$('#loader').fadeOut(speedx2);
	}, speed);
	window.addEventListener('beforeunload', function (){
		$('#loader').fadeIn(speedx2);
	});

	//Menu Trigger
	$('#menu-trigger').click(function(){
		$(this).toggleClass('active');
		$('menu').toggle('slide', {
			direction: 'up',
			duration: speedx2,
			easing: ease,
			// complete: function(){
			//
			// }
		});
		hideSearch()
	});

	//Minicart
	$('.cart-trigger, #minicart-close').click(function(e){
		e.stopPropagation();
		toggleCart();
	});
	minicart.click(function(e){
		e.stopPropagation();
	});
	$(document).click(function(){
		if(minicart.is(':visible')){
			toggleCart();
		}
	});

	//Pop-up
	$('.pop-up').each(function(){
		var t = $(this),
			 i = t.data('title');
		if(t.length){
			if(i != ''){
				if(sessionStorage.getItem(i) != 'true'){
					setTimeout(function(){
						t.fadeIn()
					}, t.data('timer')*1000);
				}else{
					t.remove();
				}
			}
		}
		t.find('.pop-up-close').click(function(){
			t.fadeOut(function(){
				if(i != ''){
					t.remove();
					sessionStorage.setItem(i, true);
				}
			});
		});
	});

	//Search
	$('.search-trigger').click(function(){
		if($('menu').is(':visible') && window.innerWidth < 1025){
			$('#menu-trigger').removeClass('active');
			$('menu').toggle('slide', {
				direction: 'up',
				duration: speedx2,
				easing: ease,
				complete: function(){
					$('#pop-up_search').fadeIn()
				}
			});
		}else{
			$('#pop-up_search').fadeIn()
		}
	})

	//Subsections
	$('.trigger').click(function(){
		var t = $(this),
			 n = t.next('.collapsed');
		if(n.length){
			if($('.collapsed').not(n).is(':visible')){
				$('.collapsed:visible').slideUp(speedx2, ease, function(){
					$('.trigger').removeClass('active')
					t.addClass('active')
					n.slideDown(speedx2, ease);
				});
			}else{
				t.toggleClass('active')
				n.slideToggle(speedx2, ease);
			}
		}
	});

	//Press
	$('.trigger-press').click(function(){
		var t = $(this),
			 n = $('.press-section[data-press="'+t.data('press')+'"]'),
			 top = $('.module-press').offset().top - $('#header-wrapper').height();
		$('.press-section:visible').hide()
		$('.trigger-press').removeClass('active');
		t.addClass('active');
		n.fadeIn(speedx2, ease);
		$('html, body').animate({
			scrollTop: top
		}, 0);
	});

	//Newsletters
	// $('form.newsletter').each(function(e){
	// 	var t = $(this),
	// 		 i = t.find('input[type="email"]'),
	// 		 s = '';
	// 	t.submit(function(e){
	// 		//e.preventDefault()
	// 		if(i.val() !== '' && s == ''){
	// 			$.ajax({
	// 				type: 'POST',
	// 				url: t.attr('action'),
	// 				data: t.serialize(),
	// 				async: true,
	// 				success: function(){
	// 					e.preventDefault()
	// 					t.addClass('submitted success')
	// 					i.val('Thank you!').trigger('blur')
	// 				},
	// 				error: function(response){
	// 					if(response.status == 429){
	// 						s = 'null';
	// 						t.submit()
	// 					}else{
	// 						e.preventDefault()
	// 						t.addClass('submitted error')
	// 						i.val('Error').trigger('blur')
	// 					}
	// 				}
	// 			});
	// 			return false;
	// 		}
	// 	});
	// });

	//Form triggers
	$('.form-trigger').click(function(){
		var t = $(this),
			 d = t.data('name'),
			 c = t.data('active'),
			 id = t.data('form'),
			 n = $('#'+id);
		if(n.length){
			if($('.form-collapsed').not(n).is(':visible')){
				$('.form-trigger').each(function(){
					$(this).text($(this).data('name')).removeClass('active');
				});
				t.text(c).addClass('active')
				$('.form-collapsed:visible').slideUp(speed, ease, function(){
					n.slideDown(speed, ease);
				});
			}else{
				t.text(t.text() == c ? d : c).toggleClass('active')
				n.slideToggle(speed, ease);
			}
		}
	});

	//Guide
	const guide = $('.module-guide');
	// function resetGuide(){
	// 	if(!guide.hasClass('transition')){
	// 		$('.module-guide_anchor, .module-guide-number').removeClass('active');
	// 	}
	// }
	if(guide.length){
		var p
			//  scroller2,
			//  timer2 = function(){
			// 	scroller2 = setInterval(function(){
			// 		var psw = guide.get(0).scrollWidth,
			// 			 pos = guide.scrollLeft();
			// 		if(psw - pos != $(document).width()){
			// 			guide.scrollLeft(++pos);
			// 		}else{
			// 			clearInterval(scroller2);
			// 		}
			// 	}, 40);
			//  },
			//  observer2 = new IntersectionObserver(function(E){
			// 	E.forEach(function(entry){
			// 		if(window.innerWidth > 600){
			// 			if(entry.isIntersecting){
			// 				clearInterval(scroller2);
			// 				timer2();
			// 			}else{
			// 				clearInterval(scroller2);
			// 			}
			// 		}
			// 	});
			// });
		if(b.hasClass('desktop')){
			guide.draggable({
				start: function(e, ui){
					if(window.innerWidth > 600){
						p = guide.scrollLeft();
					}
				},
				drag: function(e, ui){
					if(window.innerWidth > 600){
						guide.scrollLeft(p + ui.position.left * -1);
						clearInterval(scroller2);
						observer2.unobserve(guide[0]);
					}
					resetGuide()
				}
			});
		}
		// observer2.observe(guide[0]);
	}
	// guide.scroll(function(){
	// 	resetGuide()
	// });

	//Guide Anchors
	$('.module-guide_anchor').click(function(){
		var t = $(this),
			 v = t.data('pos'),
			 p = $('#shopify-section-module-guide .module-guide');
		//Block scroll actions
		guide.addClass('transition');
		//Stop Auto Scroll
		// clearInterval(scroller2);
		//Deactive blocks
		$('.module-guide_anchor, .module-guide-number').removeClass('active');
		$('.module-guide-block').removeClass('arrow-active');
		//Active Current block
		t.addClass('active');
		if(t.is(':last-child')){
			$('.module-guide-block').first().addClass('arrow-active')
		}else{
			$('.module-guide-block[data-slide="'+v+'"]').next().addClass('arrow-active')
		}
		$('.module-guide-block[data-slide="'+v+'"]').find('.module-guide-number').addClass('active');
		//Scroll to block
		p.animate({
			scrollLeft: $('.module-guide-block[data-slide="'+v+'"]').offset().left - $('.module-guide-heading').outerWidth(true) - 40 + p.scrollLeft()
		}, speedx2, ease, function(){
			guide.removeClass('transition');
		});
	});

	//Guide Arrow
	$('#module-guide_arrow').click(function(){
		var t = $('.module-guide-block.arrow-active'),
			 v = t.data('slide'),
			 p = $('#shopify-section-module-guide .module-guide');

		//Block scroll actions
	 	guide.addClass('transition');
		//Stop Auto Scroll
		// clearInterval(scroller2);
		//Deactive blocks
		$('.module-guide_anchor, .module-guide-number').removeClass('active');
		//Active Current block
		$('.module-guide_anchor[data-pos="'+v+'"]').addClass('active');
		t.find('.module-guide-number').addClass('active');
		//Scroll to block
		p.animate({
			scrollLeft: $('.module-guide-block.arrow-active').offset().left - $('.module-guide-heading').outerWidth(true) - 40 + p.scrollLeft()
		}, speedx2, ease, function(){
			guide.removeClass('transition');
			if(t.is(':last-child')){
				$('.module-guide-block').first().addClass('arrow-active');
			}else{
				t.next().addClass('arrow-active');
			}
			t.removeClass('arrow-active');
		});

	});
  
	//Quiz mother
	const quizmother = $('#shopify-section-quiz-mother .quiz-block').length,
			backmother = $('#shopify-section-quiz-mother #quiz-back-mother'),
			clockmother = $('#clock'),
			clockTimermother = $('#timer');
	if(clockmother.length){
		sessionStorage.setItem('quiz', false);
	}
  
	//Quiz Step Back mother
	backmother.click(function(){
		var tmother = $('#shopify-section-quiz-mother .quiz-block').not('.hide'),
			 imother = tmother.index() - 1,
			 prevmother = tmother.prev();
		backmother.css('pointer-events', 'none');
        console.log("Quiz Back Mother: " + imother);
		if ($("#quiz-back-mother").is(".in-form")){
          console.log("finali finali finali");
          location.reload();
          /*setTimeout(function(){
            $("#shopify-section-quiz-mother").removeClass("hide");
            $("#shopify-section-quiz-mother  .quiz-block:last-child").removeClass("hide");
            $("#quiz-back-mother").removeClass("in-form");
          }, speedx2);*/
        }else if(imother == 0){
            $("#shopify-section-quiz-mother").addClass("hide");
            setTimeout(function(){
              $("#shopify-section-quiz-start").removeClass("hide");
              // t.removeClass("hide");
            }, speedx2);
		}else{
		}
		tmother.addClass('hide');
		setTimeout(function(){
			prevmother.removeClass('hide');
			prevmother.find('input').prop('checked', false);
			sessionStorage.setItem('quiz', clockTimermother.text());
			backmother.css('pointer-events', 'all');
		}, speedx2);
		$('#quiz-progress span').css('width', 'calc((100%/'+quizmother+')*'+imother+')');

		//Timer
		var current = parseFloat(clockTimermother.text()),
			 extra = Number(prevmother.find('input:checked').val()),
			 total = current - extra,
			 time = parseInt(clockmother.css('--time'),10),
			 mins = time - extra*-6;

		if(current == 0 && extra < 0){
			clockTimermother.text('00')
			mins = '0';
		}else{
			if(total > 0){
				clockTimermother.text(total);
				if(mins < -180){
					clockmother.get(0).style.setProperty('--pos', '-1')
					clockmother.get(0).style.setProperty('--bg', 'var(--c-bg)')
				}else{
					clockmother.get(0).style.setProperty('--pos', '1')
					clockmother.get(0).style.setProperty('--bg', 'var(--red)');
				}
			}else{
				clockTimermother.text('00')
				mins = '0';
			}
		}
		clockmother.get(0).style.setProperty('--time', mins);

	});

    //Quiz daughter
    const quizdaughter = $('#shopify-section-quiz-body .quiz-block').length,
            backdaughter = $('#shopify-section-quiz-body #quiz-back-body'),
            clockdaughter = $('#clock'),
            clockTimerdaughter = $('#timer');
    if(clockdaughter.length){
        sessionStorage.setItem('quiz', false);
    }
    
    //Quiz Step Back daughter
    backdaughter.click(function(){
        var t = $('#shopify-section-quiz-body .quiz-block').not('.hide'),
             i = t.index() - 1,
             prev = t.prev();
        backdaughter.css('pointer-events', 'none');
        console.log("Quiz Back Daughter: " + i);
        if ($("#quiz-back-body").is(".in-form")){
          console.log("finali finali finali")
          location.reload();
          /*setTimeout(function(){
            $("#shopify-section-quiz-body").removeClass("hide");
            $("#shopify-section-quiz-body  .quiz-block:last-child").removeClass("hide");
            $("#quiz-back-body").removeClass("in-form");
          }, speedx2);*/
        }else if(i == 0){
            $("#shopify-section-quiz-body").addClass("hide");
            setTimeout(function(){
              $("#shopify-section-quiz-start").removeClass("hide");
              // t.removeClass("hide");
            }, speedx2);
        }else{
        }
        t.addClass('hide');
        setTimeout(function(){
            prev.removeClass('hide');
            prev.find('input').prop('checked', false);
            sessionStorage.setItem('quiz', clockTimerdaughter.text());
            backdaughter.css('pointer-events', 'all');
        }, speedx2);
        $('#quiz-progress span').css('width', 'calc((100%/'+quizdaughter+')*'+i+')');
    
        //Timer
        var current = parseFloat(clockTimerdaughter.text()),
             extra = Number(prev.find('input:checked').val()),
             total = current - extra,
             time = parseInt(clockdaughter.css('--time'),10),
             mins = time - extra*-6;
    
        if(current == 0 && extra < 0){
            clockTimerdaughter.text('00')
            mins = '0';
        }else{
            if(total > 0){
                clockTimerdaughter.text(total);
                if(mins < -180){
                    clockdaughter.get(0).style.setProperty('--pos', '-1')
                    clockdaughter.get(0).style.setProperty('--bg', 'var(--c-bg)')
                }else{
                    clockdaughter.get(0).style.setProperty('--pos', '1')
                    clockdaughter.get(0).style.setProperty('--bg', 'var(--red)');
                }
            }else{
                clockTimerdaughter.text('00')
                mins = '0';
            }
        }
        clockdaughter.get(0).style.setProperty('--time', mins);
    
    });

    //Quiz Sections mother
    $('#shopify-section-quiz-mother .quiz-block').each(function(index){
    	var t = $(this),
    			i = index + 2,
    			next = t.next();
    	t.find('label span').click(function(){
            // console.log("Quiz mother: " + i);
    		t.addClass('hide');
    		/*if(t.is(':nth-child(2)')){
    			back.fadeIn(speed);
    		}*/
    		if(t.is(':last-child')){
    			$('#wrapper').css({
    				'color': 'var(--c-bg)',
    				'background-color': 'var(--green)'
    			});
    			next = $('#quiz-subscription-mother');
                setTimeout(function(){
                  var timetext = $("#timer").text()
                  timetext = parseInt(timetext)
                  console.log(timetext);
                  if (timetext > 24) {
                    $(".form-mother-01").addClass("show");
                    // window.location.hash = "mother1";
                  } else if (timetext > 14) {
                    $(".form-mother-02").addClass("show");
                    // window.location.hash = "mother2";
                  } else if (timetext > 4) {
                    $(".form-mother-03").addClass("show");
                    // window.location.hash = "mother3";
                  } else {
                    $(".form-mother-04").addClass("show");
                    // window.location.hash = "mother4";
                  }
                  $("#quiz-back-mother").addClass("in-form");
                  $("#quiz-back-mother").text("Start over");
                }, speedx2);
    		}
    		setTimeout(function(){
    			next.removeClass('hide')
    			sessionStorage.setItem('quiz', clockTimermother.text());
    		}, speedx2);
    		$('#quiz-progress span').css('width', 'calc((100%/'+quizmother+')*'+i+')');
    
    		//Timer
    		var current = parseFloat(clockTimermother.text()),
    				extra = Number($(this).prev('input').val()),
    				total = current + extra,
    				time = parseInt(clockmother.css('--time'),10),
    				mins = time + extra*-6;
    
    		if(total > 0){
    			clockTimermother.text(total);
    			if(mins < -180){
    				clockmother.get(0).style.setProperty('--pos', '-1')
    				clockmother.get(0).style.setProperty('--bg', 'var(--c-bg)')
    			}else{
    				clockmother.get(0).style.setProperty('--pos', '1')
    				clockmother.get(0).style.setProperty('--bg', 'var(--red)');
    			}
    		}else{
    			clockTimermother.text('00')
    			mins = '0';
    		}
    		clockmother.get(0).style.setProperty('--time', mins);
    
    	});
    });

    //Quiz Sections daughter
    $('#shopify-section-quiz-body .quiz-block').each(function(index){
    	var t = $(this),
    			i = index + 2,
    			next = t.next();
    	t.find('label span').click(function(){
            // console.log("Quiz daughter: " + i);
    		t.addClass('hide');
    		/*if(t.is(':nth-child(2)')){
    			back.fadeIn(speed);
    		}*/
    		if(t.is(':last-child')){
    			$('#wrapper').css({
    				'color': 'var(--c-bg)',
    				'background-color': 'var(--green)'
    			});
    			next = $('#quiz-subscription-body');
                setTimeout(function(){
                  var timetext = $("#timer").text()
                  timetext = parseInt(timetext)
                  console.log(timetext);
                  if (timetext > 24) {
                    $(".form-daughter-01").addClass("show");
                    // window.location.hash = "daughter1";
                  } else if (timetext > 14) {
                    $(".form-daughter-02").addClass("show");
                    // window.location.hash = "daughter2";
                  } else if (timetext > 4) {
                    $(".form-daughter-03").addClass("show");
                    // window.location.hash = "daughter3";
                  } else {
                    $(".form-daughter-04").addClass("show");
                    // window.location.hash = "daughter4";
                  }
                  $("#quiz-back-body").addClass("in-form");
                  $("#quiz-back-body").text("Start over");
                }, speedx2);
    		}
    		setTimeout(function(){
    			next.removeClass('hide')
    			sessionStorage.setItem('quiz', clockTimerdaughter.text());
    		}, speedx2);
    		$('#quiz-progress span').css('width', 'calc((100%/'+quizdaughter+')*'+i+')');
    
    		//Timer
    		var current = parseFloat(clockTimerdaughter.text()),
    				extra = Number($(this).prev('input').val()),
    				total = current + extra,
    				time = parseInt(clockdaughter.css('--time'),10),
    				mins = time + extra*-6;
    
    		if(total > 0){
    			clockTimerdaughter.text(total);
    			if(mins < -180){
    				clockdaughter.get(0).style.setProperty('--pos', '-1')
    				clockdaughter.get(0).style.setProperty('--bg', 'var(--c-bg)')
    			}else{
    				clockdaughter.get(0).style.setProperty('--pos', '1')
    				clockdaughter.get(0).style.setProperty('--bg', 'var(--red)');
    			}
    		}else{
    			clockTimerdaughter.text('00')
    			mins = '0';
    		}
    		clockdaughter.get(0).style.setProperty('--time', mins);
    
    	});
    });
    
    $( "#start-quiz" ).click(function() {
      $("#start-quiz-question").addClass("hide");
      setTimeout(function(){
        $("#mother-question").removeClass("hide");
        $("#quiz-back-start").fadeIn();
      }, speedx2);
    });
    $( "#quiz-back-start" ).click(function() {
      $("#mother-question").addClass("hide");
      $("#quiz-back-start").fadeOut();
      setTimeout(function(){
        $("#start-quiz-question").removeClass("hide");
      }, speedx2);
    });
    $( "#to-daughter" ).click(function() {
      $("#shopify-section-quiz-start").addClass("hide");
      setTimeout(function(){
        $("#shopify-section-quiz-body").removeClass("hide");
        $("#shopify-section-quiz-body .first").removeClass("hide");
        $('#quiz-progress span').css('width', 'calc(100%/'+quizdaughter+')');
      }, speedx2);
    });
    $( "#to-mother" ).click(function() {
      $("#shopify-section-quiz-start").addClass("hide");
      setTimeout(function(){
        $("#shopify-section-quiz-mother").removeClass("hide");
        $("#shopify-section-quiz-mother .first").removeClass("hide");
        $('#quiz-progress span').css('width', 'calc(100%/'+quizmother+')');
      }, speedx2);
    });

	//Quiz results
	/*$('.quick-results_wrapper').each(function(){
		var t = $(this),
			 min = t.data('start'),
			 max = t.data('end'),
			 time = sessionStorage.getItem('quiz')
		if(t.length){
			if(time <= max && time >= min){
				$('.quick-results_wrapper').not(t).remove();
				t.show();
			}
		}
	});*/

	//Slider
	$('.next').click(function(){
		nextSlide();
	});
	$('.prev').click(function(){
		prevSlide();
	});

	//Dots
	$('.dot').click(function(){
		var t = $(this),
			 p = t.parent().prev(),
			 s = p.find('.slide[data-slide="' + (t.index() + 1) + '"]');
		t.addClass('active').siblings().removeClass('active');
		p.prepend(s, s.nextAll());
	});

	//All ingredients
	$('#ingredients-trigger').click(function(e){
		$(this).toggleClass('active')
		if(window.innerWidth > 834){
			$('#ingredients-pop-up').fadeToggle(speed, ease)
		}else{
			$('#ingredients-pop-up').slideToggle(speed, ease)
		}
	});
	$('#ingredients-pop-up .pop-up-close').click(function(){
		$('#ingredients-trigger').removeClass('active')
		if(window.innerWidth > 834){
			$('#ingredients-pop-up').fadeOut(speed, ease)
		}else{
			$('#ingredients-pop-up').slideToggle(speed, ease)
		}
	})

	//Reviews
	$('#reviews-trigger').click(function(e){
		$(this).toggleClass('active').text($(this).text() == 'Close' ? 'Write a Review' : 'Close')
		$('.new-review-form').slideToggle(speed, ease)
	});
	function addEventListenerStamped(el, eventName, handler){
		if(el.addEventListener){
			el.addEventListener(eventName, handler);
		}else{
			el.attachEvent('on' + eventName, function(){
				handler.call(el);
			});
		}
	}
	addEventListenerStamped(document, 'stamped:reviews:submitted', function(e){
		$('#reviews-trigger').removeClass().text('Thank you!');
		var top = $('#product-rating').offset().top - $('#header-wrapper').height();
		$('html, body').animate({
			scrollTop: top
		}, speed, ease);
	});

	//Lazy Loading
	var L = [].slice.call(document.querySelectorAll('.lazy')),
		 P = [].slice.call(document.querySelectorAll('.picture > source'));
	if('IntersectionObserver' in window){
		let o = new IntersectionObserver(function(E, observer){
			E.forEach(function(e){
				if(e.isIntersecting){
					let t = e.target;
					if(t.tagName == 'IMG'){
						t.src = t.dataset.src;
						t.classList.remove('lazy');
					}
					if(t.tagName == 'VIDEO'){
						if(!$(t).hasClass('controls')){
							var P = t.play();
							if(P !== undefined){
								P.catch(error => {
									t.controls = true;
									t.classList.add('no-autoplay');
								});
							}
						}
						t.classList.remove('lazy');
					}
					if(t.parentElement.tagName == 'PICTURE'){
						t.srcset = t.dataset.srcset;
						t.parentElement.classList.remove('picture');
					}
					o.unobserve(t);
				}
			});
        });
		/*}, {rootMargin: '300px 0px 300px 0px'});*/
		L.forEach(function(t){
			o.observe(t);
		});
		P.forEach(function(t){
			o.observe(t);
		});
	}
    
});

/******** CART BUBBLE UPDATE START ********/

// Debounce utility function to limit rapid function calls
function debounce(func, wait = 300) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Function to update the cart item count
function updateCartItemCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElement = document.getElementById('header-cart-count');
      if (!cartCountElement) return;

      const itemCount = cart.item_count;

      // Update local storage and UI only if the item count has changed
      if (localStorage.getItem('cartItemCount') != itemCount) {
        localStorage.setItem('cartItemCount', itemCount);

        if (itemCount > 0) {
          cartCountElement.style.display = 'flex';
          cartCountElement.innerHTML = `<span aria-hidden="true">${itemCount}</span>`;
        } else {
          cartCountElement.style.display = 'none';
        }
      }
    })
    .catch(error => console.error('Error updating cart item count:', error));
}

// Initialize cart count from local storage
function initializeCartCountFromLocalStorage() {
  const storedCartCount = localStorage.getItem('cartItemCount');
  const cartCountElement = document.getElementById('header-cart-count');
  
  if (!storedCartCount || !cartCountElement) return;

  if (parseInt(storedCartCount) > 0) {
    cartCountElement.style.display = 'flex';
    cartCountElement.innerHTML = `<span aria-hidden="true">${storedCartCount}</span>`;
  } else {
    cartCountElement.style.display = 'none';
  }
}

// Observe changes to the minicart content for updates
function trackMinicartContentChanges() {
  const minicartElement = document.getElementById('minicart-content');
  if (!minicartElement) {
    // console.warn('Element #minicart-content not found on the page.');
    return;
  }

  const observer = new MutationObserver(debounce(() => {
    // console.log('Minicart content changed:', minicartElement.innerHTML);
    updateCartItemCount();
  }));

  observer.observe(minicartElement, { childList: true, subtree: true });
}

// Main initialization
document.addEventListener('DOMContentLoaded', () => {
  initializeCartCountFromLocalStorage();
  document.addEventListener('cart:updated', updateCartItemCount);

  // Attach event listeners to add-to-cart buttons
  document.querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', () => setTimeout(updateCartItemCount, 1000));
  });

  trackMinicartContentChanges();
});

/******** CART BUBBLE UPDATE END ********/








